<template>
  <div class="company-certification">
    <div class="company-certification-title">
      {{ $t('registration.sp.freelancer.company.certification.title') }}
    </div>
    <div class="company-certification-title-comment">
      {{ $t('registration.sp.freelancer.company.certification.title.comment') }}
    </div>
    <div class="company-certification-sub-title">
      {{ $t('registration.sp.freelancer.company.certification.sub.title.prefix') }}
      <span class="sub-title-blue">
        {{ $t('registration.sp.freelancer.company.certification.sub.title.blue.part') }}
      </span>
      {{ $t('registration.sp.freelancer.company.certification.sub.title.suffix') }}
    </div>
    <div class="sub-title-comment">
      {{ $t('registration.sp.freelancer.company.certification.sub.title.comment') }}
    </div>
    <CompanySPCertificationForm
      :value="spCompanyRegistrationCompanyCertificationInfo"
      :social-media-network-value="spCompanyRegistrationCompanySocialNetworkLinkInfo"
      :ip-list="spCompanyRegistrationCompanyIpAddressInfo"
      @onIpChange="onIpChange"
      @onLinkedInLinkChanged="onLinkedInLinkChanged"
      @onCertificationDataChanged="onCertificationDataChanged"
    >
    </CompanySPCertificationForm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanySPCertificationForm from '@/components/spCompanyRegistration/CompanySPCertificationForm.vue';
import {
  CHANGE_SP_COMPANY_CERTIFICATIONS_INFO,
  CHANGE_SP_COMPANY_IP_ADDRESS_INFO, CHANGE_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO,
} from '@/store/spCompanyRegistration/actionTypes';

export default {
  name: 'SPCompanyCertifications',
  components: {
    CompanySPCertificationForm,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'spCompanyRegistrationCompanyCertificationInfo',
      'spCompanyRegistrationCompanySocialNetworkLinkInfo',
      'spCompanyRegistrationCompanyIpAddressInfo',
    ]),
  },
  methods: {
    async onIpChange(data) {
      await this.$store.dispatch(CHANGE_SP_COMPANY_IP_ADDRESS_INFO, data);
    },
    async onLinkedInLinkChanged(data) {
      await this.$store.dispatch(CHANGE_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO, data);
    },
    async onCertificationDataChanged(data) {
      await this.$store.dispatch(CHANGE_SP_COMPANY_CERTIFICATIONS_INFO, data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.company-certification {
  border-radius: $radius-sm;
  background-color: $white;
  padding: rem(40) rem(80) rem(35);
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  flex: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.company-certification-title {
  color: $auth-text-primary;
  font-family: $font-family-medium;
  font-size: rem(20);
  font-weight: 500;
  letter-spacing: 0;
  line-height: rem(24);
  padding-bottom: rem(4);
}

.company-certification-title-comment {
  height: rem(16);
  color: $auth-text-muted;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  text-align: center;
  padding-bottom: rem(44);
}

.company-certification-sub-title {
  height: rem(18);
  color: $auth-text-primary;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  .sub-title-blue {
    color: $auth-brand;
  }
}

.sub-title-comment {
  height: rem(18);
  color: $auth-text-muted;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  margin-bottom: rem(32);
}
</style>
